// extracted by mini-css-extract-plugin
module.exports = {"theme":"#e70012"};